import axios from "axios";
import { api } from "./api_route";

export const getCommAuditTrails = async (data) => {
  try {
    const response = await axios.post(`${api}/commAuditTrails/get`, data);
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const searchCasesApi = async (data) => {
  try {
    const response = await axios.post(
      `${api}/commAuditTrails/casesValidation`,
      data,
    );
    return response;
  } catch (error) {
    throw error;
  }
};

export const createCommAuditTrail = async (data) => {
  try {
    if (Array.isArray(data?.mailAttachment) && data.mailAttachment.length > 0) {
      const { mailAttachment, ...payload } = data;
      const formData = new FormData();
      for (const file of mailAttachment) {
        formData.append("files", file);
      }
      formData.append("data", JSON.stringify(payload));
      const response = await axios.post(
        `${api}/commAuditTrails/create`,
        formData,
      );
      return response.data;
    }
    const response = await axios.post(`${api}/commAuditTrails/create`, data);
    return response.data;
  } catch (error) {
    throw error;
  }
};
